import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';
import Panel from './panel';

import shape1 from './images/shape-1.svg';
import shape2 from './images/shape-2.svg';

import styles from './mobile-access-dashboard.module.scss';

const cx = classNames.bind(styles);

const MobileAccessDashboard = ({ title, description, items }) => {
  const { dashboard } = useStaticQuery(graphql`
    query {
      dashboard: file(relativePath: { eq: "mobile-access/cloud-access/dashboard.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 980)
        }
      }
    }
  `);

  return (
    <section className={cx('wrapper')}>
      <div className="container">
        <Heading className={cx('title')} tag="h2" size="xl" color="tertiary">
          {title}
        </Heading>
        <Heading
          className={cx('description')}
          tag="p"
          size="lg"
          color="tertiary"
          role="doc-subtitle"
        >
          {description}
        </Heading>

        <div className={cx('dashboard-wrapper')}>
          {items.map(({ description }, index) => (
            <div className={cx('panel', `panel-${index + 1}`)} key={index}>
              <Panel>{description}</Panel>
            </div>
          ))}

          <GatsbyImage className={cx('dashboard')} image={getImage(dashboard)} alt="" />

          <img className={cx('shape-1')} src={shape1} alt="" loading="lazy" aria-hidden />
          <img className={cx('shape-2')} src={shape2} alt="" loading="lazy" aria-hidden />
        </div>
      </div>
    </section>
  );
};

MobileAccessDashboard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MobileAccessDashboard;
